<template>
    <a
        v-if="isImpersonatingPartner()"
        class="p-menuitem-link"
        role="menuitem"
        @click="stopPartnerImpersonation"
        @mouseenter="isHovering = true"
        @mouseleave="isHovering = false"
    >
        <span class="p-menuitem-icon">
            <img src="@/assets/partner-portal-impersonate-filled.svg" />
        </span>

        <b class="p-menuitem-text">
            {{ impersonatingLabel }}
        </b>
    </a>
</template>

<script>
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import { isImpersonatingPartner, stopImpersonatingPartner } from '@/plugins/impersonatePartner';

export default {
    name: 'PartnerImpersonation',

    setup() {
        const store = useStore();

        const stopPartnerImpersonation = () => {
            stopImpersonatingPartner();
            store.dispatch('clearStateAndReload');
        };

        const isHovering = ref(false);

        return {
            isImpersonatingPartner,
            stopPartnerImpersonation,
            isHovering,
            impersonatingLabel: computed(() =>
                isHovering.value ? 'Stop impersonating' : 'You are impersonating'
            )
        };
    }
};
</script>

<style lang="scss" scoped>
.p-menuitem-text {
    font-weight: 600 !important;
}
</style>
